import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";

import Swal from "sweetalert2";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import {
  getVendors,
  vendorAdd,
  vendorDelete,
  vendorEdit,
  model_open,
  model_close,
  InputChangeValue,
  SelecteChangeValue,
  vendorGSTValidation,
} from "../../../store/Masters/Vendors/actions";
import { getState } from "../../../store/Mini/actions";

class AddVendor extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    if (this.props.rowdata.state_id != null) {
      var VendorData = {
        id: this.props.rowdata.id,
        name: this.props.rowdata.name,
        mobile: this.props.rowdata.mobile,
        email: this.props.rowdata.email,
        address: this.props.rowdata.address,
        city: this.props.rowdata.city,
        state_id: this.props.rowdata.state_id,
        gstno: this.props.rowdata.gstno,
        person_name: this.props.rowdata.person_name,
        person_mobile: this.props.rowdata.person_mobile,
      };

      this.props.vendorAdd(VendorData, this.props.history);
    } else {
      Swal.fire({
        icon: "error",
        title: "Please Select State",
      });
    }
  }
  componentDidMount() {
    this.props.getState();
  }

  render() {
    var data = this.props.rowdata;

    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            ADD VENDOR
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={12}>
                      <FormGroup>
                        <Label htmlFor="VendorName" className="col-form-label ">
                          Vendor Name
                        </Label>

                        <AvField
                          name="name"
                          type="text"
                          value={data.name}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="VendorName"
                          placeholder="Enter Vendor Name"
                          errormessage=" Please provide a valid Vendor Name"
                          validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="Mobno" className="col-form-label ">
                          Vendor Mobile No
                        </Label>

                        <AvField
                          name="mobile"
                          mask="(999)-999-9999"
                          type="text"
                          value={data.mobile}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="Mobno"
                          placeholder="Enter Mobile No"
                          errormessage=" Please provide a valid Mobile No"
                          validate={{
                            required: { value: true },
                            pattern: {
                              value: "[1-9]{1}[0-9]{9}",
                              errorMessage:
                                "Mobile No must be be 10 characters and it should numbers [0-9]",
                            },
                            minLength: {
                              value: 10,
                              errorMessage: "Mobile No must be 10 characters",
                            },
                            maxLength: {
                              value: 10,
                              errorMessage: "Mobile No must be 10 characters",
                            },
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="Email" className="col-form-label ">
                          Vendor Email ID
                        </Label>

                        <AvField
                          name="email"
                          type="email"
                          value={data.email}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="Email"
                          placeholder="Enter Email"
                          errormessage=" Please provide a valid Email"

                          // validate={{
                          //   required: { value: true },
                          // }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="personName" className="col-form-label ">
                          Contact Person Name
                        </Label>

                        <AvField
                          name="person_name"
                          type="text"
                          value={data.person_name}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="personName"
                          placeholder="Enter person name"
                          errormessage=" Please provide a valid person name"
                          // validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label
                          htmlFor="PersonMobile"
                          className="col-form-label "
                        >
                          Contact Person Mobile No
                        </Label>

                        <AvField
                          name="person_mobile"
                          mask="(999)-999-9999"
                          type="text"
                          pattern="[1-9]{1}[0-9]{9}"
                          value={data.person_mobile}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="PersonMobile"
                          placeholder="Enter Person Mobile No"
                          errormessage=" Please provide a valid Person Mobile No"
                          validate={{
                            // required: { value: true },
                            pattern: {
                              value: "[1-9]{1}[0-9]{9}",
                              errorMessage:
                                "Person Mobile No must be be 10 characters and it should numbers [0-9]",
                            },
                            minLength: {
                              value: 10,
                              errorMessage:
                                "Person Mobile No must be 10 characters",
                            },
                            maxLength: {
                              value: 10,
                              errorMessage:
                                "Person Mobile No must be 10 characters",
                            },
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="gstno" className="col-form-label ">
                          GST No
                        </Label>

                        <AvField
                          name="gstno"
                          type="text"
                          value={data.gstno}
                          onChange={this.ChangeHandeler}
                          onBlur={(e) => {
                            if (e.target.value.length === 15) {
                              this.props.vendorGSTValidation({
                                id: data.id,
                                gstno: e.target.value,
                              });
                            }
                          }}
                          className="form-control"
                          id="gstno"
                          placeholder="Enter GST No"
                          errormessage=" Please provide a valid GST no"
                          validate={{
                            // required: { value: true },
                            pattern: {
                              value: "^[A-Za-z0-9]+$",
                              errorMessage:
                                "GST No must be be 15 characters and must be composed only with letter and numbers",
                            },
                            minLength: {
                              value: 15,
                              errorMessage: "GST No must be 15 characters",
                            },
                            maxLength: {
                              value: 15,
                              errorMessage: "GST No must be 15 characters",
                            },
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label
                          htmlFor="state_select"
                          className="col-form-label "
                        >
                          Select State
                        </Label>

                        <Select
                          id="state_select"
                          name="state_select"
                          classNamePrefix="select2-selection"
                          // isClearable={
                          //   this.props.rowdata?.MenuLabel ? true : false
                          // }
                          options={this.props.statelist.map((item, index) => ({
                            label: item.name,
                            value: item.id,
                          }))}
                          value={{
                            label:
                              data.stateLabel == null
                                ? "Select State"
                                : data.stateLabel,
                            value: data.state_id,
                          }}
                          onChange={(e) => {
                            this.props.SelecteChangeValue({
                              key: "stateLabel",
                              label: e?.label,
                              key2: "state_id",
                              value: e?.value,
                            });
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="city" className="col-form-label ">
                          Vendor City
                        </Label>

                        <AvField
                          name="city"
                          type="text"
                          value={data.city}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="city"
                          placeholder="Enter City"
                          errormessage=" Please provide a valid City"
                          // validate={{ required: { value: true } }}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="Address" className="col-form-label">
                          Vendor Address
                        </Label>

                        <AvField
                          name="address"
                          type="textarea"
                          value={data.address}
                          onChange={this.ChangeHandeler}
                          className="form-control"
                          id="Address"
                          placeholder="Enter Address"
                          errormessage=" Please provide a valid Address"
                          // validate={{ required: { value: true } }}
                        />
                      </FormGroup>

                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                    {data.id && data.id !== 0 && (
                      <>
                        <Col md={6}>
                          <FormGroup>
                            <Label htmlFor="vendor_code" className="col-form-label">
                              Code
                            </Label>
                            <AvField
                              name="code"
                              type="text"
                              value={data.code || ""}
                              onChange={this.ChangeHandeler}
                              className="form-control"
                              id="vendor_code"
                              placeholder="Enter Code"
                            />
                            <span className="text-danger mt-0">
                              {this.props.error_msg?.code}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label htmlFor="vendor_erp_id" className="col-form-label">
                              ERP ID
                            </Label>
                            <AvField
                              name="erp_id"
                              type="text"
                              value={data.erp_id || ""}
                              onChange={this.ChangeHandeler}
                              className="form-control"
                              id="vendor_erp_id"
                              placeholder="Enter ERP ID"
                            />
                            <span className="text-danger mt-0">
                              {this.props.error_msg?.erp_id}
                            </span>
                          </FormGroup>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <button
                  // type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { statelist } = state.Mini;
  const { model, message, error_msg, rowdata } = state.Vendor;
  return { model, message, error_msg, rowdata, statelist };
};

export default connect(mapStatetoProps, {
  getState,
  getVendors,
  vendorAdd,
  vendorDelete,
  vendorEdit,
  model_open,
  model_close,
  InputChangeValue,
  SelecteChangeValue,
  vendorGSTValidation,
})(AddVendor);
